export const actionTypes = {
  UPDATE_BACK_ROUTE: 'UPDATE_BACK_ROUTE',
};

export const updateBackRoute = (routeBack) => ({
  type: actionTypes.UPDATE_BACK_ROUTE,
  routeBack,
});
